<template>
  <default-layout>
    <section slot="content">
      <template>
        <div>
          <template>
            <v-row justify="center">
              <v-col cols="12" md="12" xs="12">
                <v-expansion-panels multiple v-model="panel">
                  <v-expansion-panel>
                    <v-expansion-panel-header class="tile">
                      <v-col
                        cols="12"
                        sm="6"
                      >
                        <b>CALENDARIO DE ENTREGAS</b>
                      </v-col>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row dense align="center" justify="center">
                        <v-col cols="12">
                          <v-card flat>
                            <v-card-text>
                              <template>
                                <v-row class="fill-height">
                                  <v-col>
                                    <v-sheet height="64">
                                      <v-toolbar
                                        flat
                                      >
                                        <v-btn
                                          outlined
                                          class="mr-4"
                                          color="grey darken-2"
                                          @click="setToday"
                                        >
                                          HOY
                                        </v-btn>
                                        <v-btn
                                          fab
                                          text
                                          small
                                          color="grey darken-2"
                                          @click="prev"
                                        >
                                          <v-icon small>
                                            mdi-chevron-left
                                          </v-icon>
                                        </v-btn>
                                        <v-btn
                                          fab
                                          text
                                          small
                                          color="grey darken-2"
                                          @click="next"
                                        >
                                          <v-icon small>
                                            mdi-chevron-right
                                          </v-icon>
                                        </v-btn>
                                        <v-toolbar-title v-if="$refs.calendar">
                                          {{ $refs.calendar.title }}
                                        </v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-menu
                                          bottom
                                          right
                                        >
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                              outlined
                                              color="grey darken-2"
                                              v-bind="attrs"
                                              v-on="on"
                                            >
                                              <span>{{ typeToLabel[type] }}</span>
                                              <v-icon right>
                                                mdi-menu-down
                                              </v-icon>
                                            </v-btn>
                                          </template>
                                          <v-list>
                                            <v-list-item @click="type = 'day'">
                                              <v-list-item-title>Día</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'week'">
                                              <v-list-item-title>Semana</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = 'month'">
                                              <v-list-item-title>Mes</v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="type = '4day'">
                                              <v-list-item-title>4 días</v-list-item-title>
                                            </v-list-item>
                                          </v-list>
                                        </v-menu>
                                      </v-toolbar>
                                    </v-sheet>
                                    <v-sheet height="600">
                                      <v-calendar
                                        ref="calendar"
                                        v-model="focus"
                                        color="primary"
                                        :events="events"
                                        :event-color="getEventColor"
                                        :type="type"
                                        @click:event="showEvent"
                                        @click:more="viewDay"
                                        @click:date="viewDay"
                                        @change="updateRange"
                                      ></v-calendar>
                                      <v-menu
                                        v-model="selectedOpen"
                                        :close-on-content-click="false"
                                        :activator="selectedElement"
                                        offset-x
                                      >
                                        <v-card
                                          color="grey lighten-4"
                                          min-width="350px"
                                          flat
                                        >
                                          <v-toolbar
                                            :color="selectedEvent.color"
                                            dark
                                          >
                                            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                                          </v-toolbar>
                                          <v-card-text>
                                            <span v-html="selectedEvent.details"></span>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-btn
                                              text
                                              color="secondary"
                                              @click="selectedOpen = false"
                                            >
                                              Cerrar
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-menu>
                                    </v-sheet>
                                  </v-col>
                                </v-row>
                              </template>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-row>
          </template>
        </div>
      </template>

      <template>
        <v-snackbar
          v-model="snackbar"
        >
          {{ text }}

          <template v-slot:action="{ attrs }">
            <v-btn
              color="pink"
              text
              v-bind="attrs"
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </template>
        </v-snackbar>
      </template>

      <template>
        <div class="text-center">
          <v-overlay :value="overlay" z-index="500">
            <v-progress-circular
              indeterminate
              size="70"
              width="7"
              color="primary"
            ></v-progress-circular>
          </v-overlay>
        </div>
      </template>

    </section>
  </default-layout>
</template>
<script>
  import DefaultLayout from '@/layouts/DefaultLayout'
  import axios from 'axios'
  import moment from 'moment'
  import { Chart } from 'highcharts-vue'

  axios.defaults.baseURL = process.env.DINO.ENDPOINT;

  moment.locale('es');

  export default {
    name: 'DeliveryCalendarView',
    components: {
      DefaultLayout,
      highcharts: Chart
    },
    data () {
      return {
        overlay: false,
        panel: [0, 1, 2],

        focus: '',
        type: 'month',
        typeToLabel: {
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          '4day': '4 Días',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        events: [],
        colors: ['red', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        // ************ snackbar ************
        snackbar: false,
        text: '',
        color: 'green',
        // **********************************
      }
    },
    methods: {
      showMessage(text, color) {
        this.snackbar = true;
        this.text = text;
        this.color = color;
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({start, end}) {
        this.overlay = true;
        axios.defaults.headers = {
          'authorization': localStorage.getItem('authorization')
        };
        axios.get(process.env.DINO.PATH.GET_DELIVERIES_CALENDAR, {
          params: {
            start: start.date,
            end: end.date
          }
        }            )
        .then(response => {
          const events = [];
          for (let i = 0; i < response.data.length; i++) {

            const clientDelivery = response.data[i];
            let color = 'grey darken-1';

            if (clientDelivery.shipping_type == 'MOTORIZADO') {
              color = 'red';
            } else if (clientDelivery.shipping_type == 'ALMACEN') {
              color = 'green';
            } else if (clientDelivery.shipping_type == 'AGENCIA') {
              color = 'deep-purple';
            } else {
              color = 'grey darken-1';
            }

            events.push({
              name: `${clientDelivery.shipping_type} - ${clientDelivery.phone}`,
              start: clientDelivery.delivery_day,
              end: clientDelivery.delivery_day,
              color: color,
              timed: false,
            })
          }
          this.events = events;
        })
        .catch((err) => {
          console.log(err);
          this.showMessage('Hubo un problema en el servidor', 'red');
        })
        .then(() => {
          this.overlay = false;
        });
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },

      logout: function() {
        localStorage.clear();
        window.location.href = "/";
      }
    },

    mounted: function () {
      axios.defaults.headers = {
        'authorization': localStorage.getItem('authorization')
      };

      this.$refs.calendar.checkChange();
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/order/DeliveryCalendar.vue